import { Change } from '../types'

export function upDownMarker(change?: Change) {
  if (!change) {
    return ''
  }

  switch (change) {
    case 'UPPER_LIMIT':
    case 'RISE':
      return '+'
    case 'FALL':
    case 'LOWER_LIMIT':
      return '-'
    default:
      return ''
  }
}

export function getStatusByPercent(change?: Change): UpDown {
  if (!change) {
    return 'draw'
  }

  switch (change) {
    case 'UPPER_LIMIT':
    case 'RISE':
      return 'up'
    case 'FALL':
    case 'LOWER_LIMIT':
      return 'down'
    default:
      return 'draw'
  }
}

type UpDown = 'up' | 'draw' | 'down'
